// extracted by mini-css-extract-plugin
export default {"root":"DMActionsInfo_root__srzPm","container":"DMActionsInfo_container__YDi7W","header":"DMActionsInfo_header__sBpzQ","body":"DMActionsInfo_body__vlzLz"};